import React from 'react';
import { Chip } from './style';

const FilterChip = ({ ...rest }) => {
  return <Chip {...rest} />;
};

export default FilterChip;
